<template>
    <div :style="useMinHeight ? 'min-height:'+height+'px;' : ''">
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <div v-if="!loading&&objectUrn" :style="{height:height+'px'}">
            <forge-vuer
                :getAccessToken="getToken"
                ref="forgevuer"
                @selection-changed-event="handleSelectionChange"
                @geometry-loaded-event="applySelection"
                @model-root-loaded-event="initialSetup"
                :urn="objectUrn"/>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import LoadingProgressBar from './../LoadingProgressBar'
import ForgeVuer from 'forge-vuer';

export default {
    props: {
        url: {type: String, default: null},
        height: {type: Number, default: 800},
        lightingPreset: {type: Number, default: null},
        selectedItems: {type: Array, default: null},
        highlightedItems: {type: Array, default: null},
        selectionColor: {type: String, default: null},
        nodeNamesToHide: {type: String, default: null},
        nodeNamesToRemove: {type: String, default: null},
        modeNameToFocus: {type: String, default: null},
        forcedBackground: {type: String, default: null},
        whiteMode:{type:Boolean, default: false},
        useMinHeight:{type:Boolean, default: false},
        groundShadow:{type:Boolean, default: false},
        groundReflection:{type:Boolean, default: false},
        lockNav:{type:Boolean, default: false},
    },
    components: {LoadingProgressBar, ForgeVuer},
    computed: {

    },
    name: 'ForgeViewerWidget',
    watch: {
        selectedItems(){
            this.applySelection()
        },
        url(){
            this.refresh()
        }
    },
    data: function () {
        return {
            loading: true,
            doneFirstFix: false,
            timeout: null,
            objectUrn: null,
        }
    },
    mounted() {
        this.refresh()
    },
    beforeDestroy() {
        this.cleanupViewer();
    },
    methods: {
        cleanupViewer() {
            if (this.$refs.forgevuer&&this.$refs.forgevuer.viewerService){
                const viewer = this.$refs.forgevuer.viewerService.Viewer3D;
                if (viewer) {
                    viewer.unloadModel(viewer.model);
                    viewer.finish();
                    this.$refs.forgevuer.viewerService.Viewer3D = null;
                }
            }

        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.reloadViewer, 500);
        },
        handleSelectionChange(eventData){
            this.$emit('select', eventData)
        },
        hexToRgb(hex) {
            const bigint = parseInt(hex.slice(1), 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
            return [r, g, b];
        },
        initialSetup(){
            this.$refs.forgevuer.viewerService.Viewer3D.setQualityLevel(true, true)
            this.$refs.forgevuer.viewerService.Viewer3D.setGroundShadow(this.groundShadow)
            this.$refs.forgevuer.viewerService.Viewer3D.setGroundReflection(this.groundReflection)
            if (this.whiteMode){
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(255,255,255,255,255,255)
            } else {
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(66,66,66,66,66,66)
            }
            if (this.lightingPreset||this.lightingPreset===0){
                this.$refs.forgevuer.viewerService.Viewer3D.setLightPreset(this.lightingPreset);
            }
            if (this.highlightedItems&&this.highlightedItems.length>0){
                for (let item of this.highlightedItems){
                    let color = item.color ? new THREE.Vector4(item.color[0]/255, item.color[1]/255, item.color[2]/255,0.7) : new THREE.Vector4(61/255, 220/255, 132/255,0.7)
                    this.$refs.forgevuer.viewerService.Viewer3D.setThemingColor(item.id, color)
                }
            }
            if (this.forcedBackground&&this.forcedBackground!==""){
                let [r, g, b] = this.hexToRgb(this.forcedBackground);
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(r, g, b, r, g, b);
            }
            if (this.lockNav){
                this.$refs.forgevuer.viewerService.Viewer3D.setNavigationLock(true);
            }
          let namesToRemove=this.nodeNamesToRemove ? this.nodeNamesToRemove.split(',') : []
          if (namesToRemove&&namesToRemove.length > 0) {
            for (let itemName of namesToRemove) {
              this.$refs.forgevuer.viewerService.Viewer3D.search(itemName, (dbIds) => {
                if (dbIds.length > 0) {
                  for (let dbId of dbIds) {
                    this.$refs.forgevuer.viewerService.Viewer3D.model.visibilityManager.setNodeOff(dbId, true);
                  }
                }
              }, null, ['name']);
            }
          }

            let namesToHide=this.nodeNamesToHide ? this.nodeNamesToHide.split(',') : []
            if (namesToHide&&namesToHide.length > 0) {
              for (let itemName of namesToHide) {
                this.$refs.forgevuer.viewerService.Viewer3D.search(itemName, (dbIds) => {
                  if (dbIds.length > 0) {
                    for (let dbId of dbIds) {
                      this.$refs.forgevuer.viewerService.Viewer3D.hide(dbId);
                    }
                  }
                }, null, ['name']);
              }
            }
          },
        applySelection(){
            if(this.selectedItems&&this.$refs.forgevuer){
                this.$refs.forgevuer.viewerService.Viewer3D.setSelectionColor(this.selectionColor)
                this.$refs.forgevuer.viewerService.Viewer3D.select(this.selectedItems)
                if(this.selectedItems.length>0){
                  this.$refs.forgevuer.viewerService.Viewer3D.fitToView(this.selectedItems)
                }
            }
            if (!this.doneFirstFix&&this.modeNameToFocus&&this.modeNameToFocus!=="" ){
                let nameToFocus=this.modeNameToFocus
                if(nameToFocus){
                  let instanceTree=this.$refs.forgevuer.viewerService.Viewer3D.model.getData().instanceTree
                  let viewer3D=this.$refs.forgevuer.viewerService.Viewer3D
                  instanceTree.enumNodeChildren(instanceTree.getRootId(), function (nodeId) {
                    const nodeName = instanceTree.getNodeName(nodeId);
                    if (nameToFocus&&nodeName===nameToFocus){
                      viewer3D.fitToView([nodeId])
                    }
                  });
                }
                this.doneFirstFix=true
            }

        },
        async getToken(onSuccess) {
            axios.post(this.url.replace('public', 'sign').replace('mode=embed', 'oauth2=true'), {}, {overrideCarnotAuth:true})
                .then(response => {
                    onSuccess(response.data.accessToken, response.data.validitySeconds);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        async reloadViewer() {
            if (this.url && this.url !== "") {
                let me = this
                me.loading = true
                let urnResponse = await axios.get(this.url.replace('public', 'metadata').replace('mode=embed', ''),{overrideCarnotAuth:true})
                me.objectUrn=urnResponse.data.success.body.viewing.views.viewableUrn
                me.loading = false
            }
        }
    },

}

</script>

<style scoped>

</style>
